<nc-confirmation-dialog titleLabel="{{title}}">
  <p [innerHTML]="message| translate"></p>
</nc-confirmation-dialog>


